import { Outlet } from 'react-router-dom';
import TabContentErrorBanner from 'components/molecules/tabs-navigation/TabContentErrorBanner';
import { TabsNavigationProvider } from 'components/molecules/tabs-navigation/TabsNavigationContext';
import { IChildrenProp } from 'types/components/components.interface';
import { TopbarPage } from '..';

interface ITopbarTabsTemplateProps extends IChildrenProp {}

const TopbarTabsTemplate = ({ children }: ITopbarTabsTemplateProps) => {
  return (
    <TabsNavigationProvider>
      <TopbarPage topbar={children}>
        <TabContentErrorBanner />
        <Outlet />
      </TopbarPage>
    </TabsNavigationProvider>
  );
};

export default TopbarTabsTemplate;
